var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "footer-back-to-top-container",
      class: { "footer-back-to-top-container--hidden": !_vm.showToTop },
      on: { click: _vm.footerToTop }
    },
    [
      _c("Icon", {
        staticClass: "footer-back-top-top-icon",
        attrs: { name: "chevron-up", size: "12px" }
      }),
      _c("p", { staticClass: "footer-back-to-top-text body-sm" }, [
        _vm._v(_vm._s(_vm.text))
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }